var map = {
	"./3/0.jpg": "lhft",
	"./3/1.jpg": "vt+5",
	"./3/10.jpg": "JoXa",
	"./3/11.jpg": "8z8U",
	"./3/12.jpg": "9I8l",
	"./3/13.jpg": "l+8c",
	"./3/2.jpg": "yOrV",
	"./3/3.jpg": "0iWE",
	"./3/4.jpg": "hf03",
	"./3/5.jpg": "IGTt",
	"./3/6.jpg": "bBQ3",
	"./3/7.jpg": "8r9z",
	"./3/8.jpg": "uXgz",
	"./3/9.jpg": "R/0j",
	"./5/0.jpg": "P+fR",
	"./5/1.jpg": "4YmR",
	"./5/2.jpg": "VBPt",
	"./5/3.jpg": "If3P",
	"./5/4.jpg": "IB7f",
	"./5/5.jpg": "fixS",
	"./5/6.jpg": "TWu4",
	"./5/7.jpg": "e4QI",
	"./5/8.jpg": "bEJR",
	"./5/9.jpg": "yZ9B",
	"./7/0.jpg": "PIvm",
	"./7/1.jpg": "ndTK",
	"./7/2.jpg": "/S/X",
	"./7/3.jpg": "+vGv",
	"./7/4.jpg": "4lbE",
	"./7/5.jpg": "81UI",
	"./7/6.jpg": "W5al",
	"./8/0.jpg": "6mpd",
	"./8/1.jpg": "wS3B",
	"./8/10.jpg": "hxWn",
	"./8/2.jpg": "pXdQ",
	"./8/3.jpg": "5eU4",
	"./8/4.jpg": "HKYk",
	"./8/5.jpg": "9NDC",
	"./8/6.jpg": "RjVz",
	"./8/7.jpg": "HDuT",
	"./8/8.jpg": "4tdN",
	"./8/9.jpg": "JbHC"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "tHqC";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sliders ^\.\/.*\.jpg$
// module id = tHqC
// module chunks = 0